import React, { useEffect } from 'react'
import * as Styled from './styles'

function getGapToMainContent(headerDisabled, footerDisabled) {
  const headerSize = 70
  const footerSize = 80

  if (headerDisabled && footerDisabled) {
    return '0px'
  }
  if (headerDisabled) {
    return `${footerSize}px`
  }
  if (footerDisabled) {
    return `${headerSize}px`
  }
  return `${headerSize + footerSize}px`
}

const AppContent = ({ children, headerDisabled, footerDisabled }) => {
  useEffect(() => {
    const setFullHeight = () => {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    }

    setFullHeight()
    window.addEventListener('resize', setFullHeight)

    return () => {
      window.removeEventListener('resize', setFullHeight)
    }
  }, [])

  return (
    <Styled.ContentBox
      gap={getGapToMainContent(headerDisabled, footerDisabled)}
    >
      {children}
    </Styled.ContentBox>
  )
}

export default AppContent
